import { ZeszytWPwComponent } from './zeszyt-w-pw/zeszyt-w-pw.component';
import { WynikiRzewnieComponent } from './home-zeszyt/wyniki-rzewnie/wyniki-rzewnie.component';
import { OpinieComponent } from './home-zeszyt/opinie/opinie.component';
import { LogowanieZeszytComponent } from './logowanie/logowanie-zeszyt.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageWithVideoComponent } from '../strona-glowna/page-with-video/page-with-video.component';
import { HomeZeszytComponent } from './home-zeszyt/home-zeszyt.component';
import { RegulaminComponent } from './regulamin/regulamin.component';
import { SiteLayoutComponent } from './site-layout/site-layout.component';
import { CasComponent } from './cas/cas.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: HomeZeszytComponent,
  },
  {
    path: 'logowanie',
    pathMatch: 'full',
    component: LogowanieZeszytComponent
  },
  {
    path: 'cas',
    component: CasComponent
  },
  {
    path: 'opinie',
    component: OpinieComponent
  },
  {
    path: 'rzewnie',
    component: WynikiRzewnieComponent
  },
  {
    path: 'pw',
    component: ZeszytWPwComponent
  },

  {
    path: '',
    component: SiteLayoutComponent,
    children: [
      { path: 'rejestracja', loadChildren: () => import('@enauka/konto').then(m => m.RejestracjaModule) },
      { path: 'konto', loadChildren: () => import('@enauka/konto').then(m => m.KontoModule) },
      { path: 'email', loadChildren: () => import('@enauka/konto').then(m => m.EmailModule) },
      { path: 'ankieta', loadChildren: () => import('@enauka/ankieta').then(m => m.AnkietaModule) },
      {
        path: 'instrukcja',
        component: PageWithVideoComponent,
        resolve: {
          page: "instrukcjaPageResolver"
        }
      },
      {
        path: 'film2020',
        component: PageWithVideoComponent,
        resolve: {
          page: "tvpFilmResolver"
        }
      },
      {
        path: 'film',
        component: PageWithVideoComponent,
        resolve: {
          page: "filmPageResolver"
        }
      },
      {
        path: 'geom/:id',
        component: PageWithVideoComponent,
        resolve: {
          page: "geomPageResolver"
        }
      },
      {
        path: 'men-instrukcja',
        component: PageWithVideoComponent,
        resolve: {
          page: "menPageResolver"
        }
      },
      {
        path: 'regulamin',
        component: RegulaminComponent,
      },
    ]
  },
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [
    {
      provide: "instrukcjaPageResolver",
      useValue: (r, s) => ({
        title: "zeszyt.online - jak zacząć?",
        urls: [
          { url: "https://storage.zeszyt.online/storage/movie/instrukcja/logowanie.mp4", type: "video/mp4" },
          { url: "https://storage.zeszyt.online/storage/movie/instrukcja/logowanie.ogg", type: "video/ogg" }
        ]
      })
    },
    {
      provide: "filmPageResolver",
      useValue: (r, s) => ({
        title: "",
        urls: [
          { url: "https://storage.zeszyt.online/storage/movie/power/demo.mp4", type: "video/mp4" },
          { url: "https://storage.zeszyt.online/storage/movie/power/demo.ogg", type: "video/ogg" }
        ]
      })
    },
    {
      provide: "geomPageResolver",
      useValue: (r, s) => {
        const filmy = {
          '1': 'konstruowanie-kata',
          '2': 'konstruowanie-kwadratu',
          '3': 'konstruowanie-odcinkow-prostopadlych',
        }
        const film = filmy[r.paramMap.get('id') || 0];
        return {
          title: "",
          urls: [
            { url: `https://storage.zeszyt.online/storage/movie/instrukcja/${film}.mp4`, type: "video/mp4" },
            { url: `https://storage.zeszyt.online/storage/movie/instrukcja/${film}.ogg`, type: "video/ogg" }
          ]
        }
      }
    },
    {
      provide: "menPageResolver",
      useValue: (r, s) => ({
        title: "",
        urls: [
          { url: "https://storage.zeszyt.online/storage/movie/instrukcja/men/instrukcja-men.mp4", type: "video/mp4" },
          { url: "https://storage.zeszyt.online/storage/movie/instrukcja/men/instrukcja-men.ogg", type: "video/ogg" }
        ]
      })
    },
    {
      provide: "tvpFilmResolver",
      useValue: (r, s) => ({
        title: "",
        urls: [
          { url: "https://storage.zeszyt.online/storage/movie/demo/tv2020.mp4", type: "video/mp4" },
          { url: "https://storage.zeszyt.online/storage/movie/demo/tv2020.ogg", type: "video/ogg" }
        ]
      })
    }
  ]
})
export class ZeszytOnlineRoutingModule {

}
